'use strict';

var modAnimationGroup_v4 = function( options ) {

    const self = this;

    this.step = function( nowIncr ) {
        // te nekā nav jo šo aizvietos ar kādu no __step funkcijām;
    };

    this.init( options );

};


modAnimationGroup_v4.prototype.init = function( options ) {

    var defaults = {

    };


    this.options = $.extend( {},
        defaults,
        options || {} );


    // šim options vajag daļu gan kā item gan kā list;

    this.animationList = null;
    this.animationListIdx = null;
    this.animationStackIdx = null;

    // grupai nav elements;
    //this.element = $();
    this.duration = 0;
    this.delay = 0;
    this.hasAnimation = false;

    this.status = 'waiting';
    this.action = null;
    this.isClone = false;


    this.canMultiply = false;
    this.autoRemoveClone = true;
    this.autoHide = false;        // tas katram elementam atsevišķi;
    this.restartClones = false;
    this.loopClones = false;    // šis darbojas ja child arī ir loop clones;
    this.noRestartIfStopping = true;


    this.multiply = false;
    this.loop = false;
    this.visible = false;

    // grupai nav width, height utt;

    // TODO: offset sub items from start??? varbūt nosaukt par offsetOpts;
    this.startOpts = {};
    this.animIdx = 0;
    this.animList = [];
    this.animLength = 0;

    //this.sizeFactor = 1;
    this.timeFactor = 1;


    // options no list;
    this.playingCount = 0;
    this.stoppedCount = 0;

};

modAnimationGroup_v4.prototype.setList = function( animationList, animationListIdx, isClone ) {
    this.animationList = animationList;
    this.animationListIdx = animationListIdx;
    this.isClone = isClone || false;
};
modAnimationGroup_v4.prototype.setStack = function( animationStackIdx ) {
    this.animationStackIdx = animationStackIdx;
};

modAnimationGroup_v4.prototype.setTimeFactor = function( timeFactor ) {
    this.timeFactor = timeFactor || 1;
    return this;
};


// ...
modAnimationGroup_v4.prototype.addGroup = function() {
    const newGroup = {
        idx: 0,
        duration: 0,
        list: {}
    };

    this.animList.push( newGroup );

    ++this.animIdx;
    ++this.animLength;

    return newGroup;
};

modAnimationGroup_v4.prototype.addToGroup = function( group, animation ) {
    const useGroup = typeof group == 'number' ? this.animList[ group ] : group;

    useGroup.list[ useGroup.idx ] = animation;
    animation.setList( this, this.listIdx );
    animation.setStack( this.listIdx );

    if (animation.hasAnimation) {
        this.hasAnimation = true;
    }

    ++useGroup.idx;
};


// ...
modAnimationGroup_v4.prototype.setAction = function( action ) {
    if (this.noRestartIfStopping) {
        if (this.action == 'stopping' && action == 'restarting') {
            return;
        }
    }

    this.action = action;
};

modAnimationGroup_v4.prototype.getDuration = function() {
    return this.duration + this.delay;
};

modAnimationGroup_v4.prototype.update = function() {
    const self = this;


    this.duration = 0;
    this.canMultiply = false; // = true ja kāds no child canMultiply = true;
    this.multiply = false; // = true ja kāds no child multiply = true;
    this.loop = false; // vienmēr pagaidām; vēlāk varbūt pieliekam ja kādam ir loop tad visu loopo;

    this.restartClones = false; //
    this.loopClones = false; //
    //this.noRestartIfStopping = true; //

    this.autoRemoveClone = true; // = true ja visi ir true;
    this.autoHide = false; // = true ja visi ir true;

    $.each( this.animList, function( groupIdx, group ) {
        group.duration = 0;

        $.each( group.list, function( animIdx, animation ) {
            animation.update();

            group.duration = Math.max(animation.getDuration(), group.duration);

            if (animation.canMultiply) {
                self.canMultiply = true;
            }
            if (animation.multiply) {
                self.multiply = true;
            }
            if (animation.loop) {
                self.loop = true;
            }

            if (animation.restartClones) {
                self.restartClones = true;
            }
            if (animation.loopClones) {
                self.loopClones = true;
            }
            if (animation.loopClones) {
                self.loopClones = true;
            }

            if (!animation.autoRemoveClone) {
                self.autoRemoveClone = false;
            }
            if (!animation.autoHide) {
                self.autoHide = false;
            }
        } );

        self.duration += group.duration;
    } );
};

// animācijai
modAnimationGroup_v4.prototype.reset = function( fromLoop ) {
    if ( fromLoop && this.isClone && !this.loopClones ) {
        return;
    }

    //console.log('animation.multiply reset group', this.options);

    // atiestatam ka nav done, ja iepriekš uzlikts kā done;
    // TODO: te resetam vajag sākot ar otro uzlikt hidden;
    $.each( this.animList, function( groupIdx, group ) {
        $.each( group.list, function( animIdx, animation ) {
            animation.reset( fromLoop );
        } );
    } );

    this.finished = false;

    this.resetTimeline();
};

modAnimationGroup_v4.prototype.resetTimeline = function() {
    // pirmā grupa palaižas uzreiz ja nav delay;
    this.durationOffset = 0;
    this.durationBreakpoint = this.delay;
    this.currentListIdx = -1;
    this.currentListItem = null;
    if (this.delay) {
        this.setDelayStep();
    } else {
        this.setNextStep();
    }

    this.nowreal = 0;
    this.now = 0;

    this.tnow = 0;
    this.prev = 0;

    this.status = 'playing';
};

modAnimationGroup_v4.prototype.__stepDelay = function( nowIncr ) {
    this.nowreal += nowIncr;
    this.now = this.nowreal - this.durationOffset;

    if (this.now >= this.durationBreakpoint) {
        const prevIdx = this.currentListIdx;

        this.setNextStep();

        if (prevIdx != this.currentListIdx) {
            // palaižam arī nākošo step ja now ir lielāks
            this.step( 0 );
        }
    }
};

modAnimationGroup_v4.prototype.__stepFinished = function( nowIncr ) {
    this.nowreal += nowIncr;
    return false;
};

modAnimationGroup_v4.prototype.__stepDefault = function( nowIncr ) {
    this.nowreal += nowIncr;
    this.now = this.nowreal - this.durationOffset;

    if (this.now >= this.durationBreakpoint) {
        this.animateCurrent( this.durationBreakpoint, true );

        const prevIdx = this.currentListIdx;

        this.setNextStep();

        if (prevIdx != this.currentListIdx) {
            // palaižam arī nākošo step ja now ir lielāks par 0 (self.nowreal - self.durationOffset;)
            this.step( 0 );
        }

        return;
    }

    this.animateCurrent( this.now, false );
};


modAnimationGroup_v4.prototype.setDelayStep = function() {
    this.step = this.__stepDelay;
};

modAnimationGroup_v4.prototype.setFinishedStep = function() {
    this.step = this.__stepFinished;
};

modAnimationGroup_v4.prototype.setNextStep = function() {
    ++this.currentListIdx;

    if (this.currentListIdx >= this.animLength) {
        this.setDone();
        return false;
    }

    this.step = this.__stepDefault;

    //this.currentOpts = $.extend( true, {}, this.animOpts );
    this.currentListItem = this.animList[ this.currentListIdx ];
    this.durationOffset += this.durationBreakpoint;
    this.durationBreakpoint = this.currentListItem.duration;
    this.prev = 0;
};

modAnimationGroup_v4.prototype.setDone = function() {
    const startDiff = this.now > this.durationBreakpoint ? this.now - this.durationBreakpoint : 0;
    let loop = this.loop && !this.finished,
        beforeFinished = this.finished;

    if (this.action == 'stopping') {
        this.action = null;
        loop = false;
    }
    else if (this.action == 'restarting') {
        this.action = null;

        let skipRestart = this.isClone && !this.restartClones;

        if (!skipRestart) {
            loop = this.loop;

            if (beforeFinished) {
                this.animationList.itemRestarted( this.animationListIdx, this.animationStackIdx, this );
            }

            beforeFinished = false;
            this.finished = false;
        }
    }

    if (loop) {
        // ja ir loop, tad resetojam pozīciju un sākam no sākuma;
        this.reset( true );
    } else {
        // ja nav loop, tad resetojam taimlainu un sākam no sākuma; ar finished = true;
        //this.setFinishedStep();
        this.resetTimeline();
        this.finished = true;
        this.status = 'finished';

        if (!beforeFinished) {
            this.animationList.itemFinished( this.animationListIdx, this.animationStackIdx, this );
        }
    }

    this.nowreal = startDiff;
    this.now = startDiff;
};


modAnimationGroup_v4.prototype.animateCurrent = function( now, finishRun ) {
    const self = this;

    if (now < 0 || this.finished) {
        // skipojam ja ir izsaukts par ātru vai jau ir beidzies;
        return;
    }
    this.tnow = now - this.prev;
    this.prev = now;

    $.each( this.currentListItem.list, function( animIdx, animation ) {
        animation.step( self.tnow );
    } );
};


modAnimationGroup_v4.prototype.clone = function() {
    var clone = new modAnimationGroup_v4({

        }),
        gr;

    $.each( this.animList, function( groupIdx, group ) {
        gr = clone.addGroup();

        $.each( group.list, function( animIdx, animation ) {
            if (!animation.hasAnimation) {
                return true;
            }
            if (!animation.canMultiply || !animation.multiply) {
                return true;
            }
            clone.addToGroup( gr, animation.clone() );
        } );
    } );

    clone.update();

    return clone;
};

modAnimationGroup_v4.prototype.remove = function() {
    $.each( this.animList, function( groupIdx, group ) {
        $.each( group.list, function( animIdx, animation ) {
            animation.remove();
        } );
    } );

    this.animationList = null;
    this.animationListIdx = null;
    this.animationStackIdx = null;

    this.duration = null;
    this.delay = null;
    this.hasAnimation = null;

    this.status = null;
    this.action = null;
    this.isClone = null;


    this.canMultiply = null;
    this.autoRemoveClone = null;
    this.autoHide = null;
    this.restartClones = null;
    this.loopClones = null;
    this.noRestartIfStopping = null;


    this.multiply = null;
    this.loop = null;
    this.visible = null;

    this.startOpts = null;
    this.animIdx = null;
    this.animList = null;
    this.animLength = null;

    this.timeFactor = null;
    this.playingCount = null;
    this.stoppedCount = null;
};

modAnimationGroup_v4.prototype.hide = function() {
    $.each( this.list, function( idx, animation ) {
        animation.hide();
    } );
};



modAnimationGroup_v4.prototype.itemFinished = function( listIdx, stackIdx, animation ) {
    //--this.playingCount;
    //++this.stoppedCount;

    if (animation.isClone && animation.autoRemoveClone) {
        //delete this.stack[ stackIdx ];
        animation.remove();
    } else if (animation.autoHide) {
        animation.hide();
    }

    // TODO:
};

modAnimationGroup_v4.prototype.itemRestarted = function( listIdx, stackIdx, animation ) {
    //++this.playingCount;
    //--this.stoppedCount;

    if (this.stoppedCount <= 0) {
        this.options.onRestart();
    }

    // TODO:
};

window.modAnimationGroup_v4 = modAnimationGroup_v4;